import { gsap } from "animations/gsap";
import { useLayoutEffect } from "react";
import styles from "./Loader.module.scss";

const Loader = () => {
  useLayoutEffect(() => {
    const tl = gsap.timeline({ repeat: -1 });
    tl.fromTo(
      ".anim-loader",
      { drawSVG: "0%" },
      {
        drawSVG: "100%",
        immediateRender: false,
        ease: "Power1.easeInOut",
        rotation: 360,
        transformOrigin: "50% 50%",
        stroke: "#fecc2f",
      }
    ).fromTo(
      ".anim-loader",
      { drawSVG: "100%" },
      {
        drawSVG: "0%",
        immediateRender: false,
        ease: "Power1.easeInOut",
        rotation: -720,
        transformOrigin: "50% 50%",
        stroke: "#29B6F6",
      }
    );

    return () => tl.current && tl.current.progress(0).kill();
  }, []);

  return (
    <svg
      className={styles.loader}
      version="1.1"
      baseProfile="tiny"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <circle
        className="anim-loader"
        fill="none"
        cx="12"
        cy="12"
        r="10"
        stroke="#29B6F6 "
        strokeWidth="2"
      />
    </svg>
  );
};

export default Loader;
